import React from 'react';
import PropTypes from 'prop-types';

import { Container } from './style';

const Text = ({ value }) => (
  <Container>
    {value}
  </Container>
);
Text.propTypes = {
  value: PropTypes.string,
};
Text.defaultProps = {
  value: '',
};

export default Text;
